import { render } from "./DFabs.vue?vue&type=template&id=4e685a1f&scoped=true"
import script from "./DFabs.vue?vue&type=script&lang=js"
export * from "./DFabs.vue?vue&type=script&lang=js"

import "./DFabs.vue?vue&type=style&index=0&id=4e685a1f&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e685a1f"]])

export default __exports__